"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processData = void 0;
function processData(input, optionMargin = "compact") {
    let length = input.length;
    let level = 0;
    let strSQL = "";
    let prePosition = 0;
    let maxLevel = 0;
    for (let i = 0; i < length; i++) {
        let letter = input.charAt(i);
        switch (letter) {
            case "➕":
                level++;
                maxLevel = Math.max(maxLevel, level);
                break;
            case "➖":
                level--;
                if (level < 0) {
                    return false;
                }
                break;
            case "⛓":
                strSQL += input.substr(prePosition, i - prePosition);
                prePosition = i + 1;
                if (optionMargin === "comfortable") {
                    strSQL += "✖" + level + " ";
                }
                break;
            case "❌":
            case "✖":
            case "⚓":
                strSQL += input.substr(prePosition, i - prePosition);
                strSQL += letter + level + " ";
                prePosition = i + 1;
                break;
            default:
                break;
        }
    }
    let lines = [
        {
            id: 0,
            value: (strSQL += input.substr(prePosition)),
            parentId: -1,
        },
    ];
    // 1. split lines
    for (let iLevel = 0; iLevel <= maxLevel; iLevel++) {
        lines
            .filter((line) => line.value !== "")
            .forEach((line) => {
            splitLine(line, "❌", iLevel);
        });
        lines
            .filter((line) => line.value !== "")
            .forEach((line) => {
            splitLine(line, "✖", iLevel);
        });
    }
    // 2. order lines
    let tmpLines = [...lines];
    lines = [];
    orderLine();
    // 3. remove end spaces
    compactLine();
    // 4. arrange anchors
    let offset = [];
    for (let iLevel = 0; iLevel <= maxLevel; iLevel++) {
        offset[iLevel] = iLevel * 4;
    }
    lines.forEach((line) => {
        alignAnchor(line);
    });
    // 5. clean markers
    lines.forEach((line) => {
        cleanMarkers(line);
    });
    // 6. make sql
    return makeSql();
    // split line using lineBreakmarker
    function splitLine(line, marker, level) {
        let length = line.value.length;
        let prePosition = 0;
        for (let i = 0; i < length; i++) {
            if (line.value.charAt(i) === marker) {
                let j = i + 1;
                for (; j < length; j++) {
                    if (line.value.charAt(j) === " ") {
                        break;
                    }
                }
                // eslint-disable-next-line eqeqeq
                if (line.value.substr(i + 1, j - i - 1) == level) {
                    lines.push({
                        id: lines.length,
                        value: line.value.substr(prePosition, i - prePosition),
                        parentId: line.id,
                    });
                    prePosition = j + 1;
                }
                i = j;
            }
        }
        if (prePosition > 0) {
            lines.push({
                id: lines.length,
                value: line.value.substr(prePosition),
                parentId: line.id,
            });
            line.value = "";
        }
    }
    // order lines
    function orderLine(id = 0) {
        let childIds = [];
        tmpLines
            .filter((line) => line.parentId === id)
            .forEach((line) => {
            childIds.push(line.id);
        });
        if (childIds.length === 0) {
            if (tmpLines[id] && tmpLines[id].value !== "") {
                lines.push(tmpLines[id]);
            }
            return;
        }
        childIds.forEach((cId) => {
            orderLine(cId);
        });
    }
    function compactLine() {
        lines
            .filter((line) => line.value !== "")
            .forEach((line) => {
            let strLine = line.value;
            // remove spaces after '\n'
            for (let i = 0; i < strLine.length; i++) {
                if (strLine.charAt(i) === "\n") {
                    if (strLine.substr(i + 1).replace(/" "/g, "") === "") {
                        line.value = strLine.substr(0, i);
                        break;
                    }
                }
            }
            // process black circle
            let tokens = line.value.split("⚫");
            if (tokens.length > 1) {
                line.value = "";
                tokens.forEach((token, idx) => {
                    token = token.trim();
                    if (optionMargin !== "compact" && idx < tokens.length - 1) {
                        token = token + " ";
                    }
                    line.value += token;
                });
            }
        });
    }
    function alignAnchor(line) {
        let length = line.value.length;
        let maxKeywordLength = 7;
        for (let i = 0; i < length; i++) {
            if (line.value.charAt(i) === "⚓") {
                let padLength = 0;
                if (i < maxKeywordLength) {
                    padLength = maxKeywordLength - i;
                }
                let level = 0;
                let j = i + 1;
                for (; j < length; j++) {
                    if (line.value.charAt(j) === " ") {
                        level = line.value.substr(i + 1, j - i - 1);
                        // check next level in this line
                        for (let k = j + 1; k < length; k++) {
                            if (line.value.charAt(k) === "⚓") {
                                let l = k + 1;
                                for (; l < length; l++) {
                                    if (line.value.charAt(l) === " ") {
                                        let nlevel = line.value.substr(k + 1, l - k - 1);
                                        if (nlevel > level) {
                                            offset[nlevel] =
                                                offset[nlevel - 1] +
                                                    l -
                                                    maxKeywordLength -
                                                    (l - k + 1);
                                        }
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                        break;
                    }
                }
                padLength += offset[level];
                line.value =
                    line.value.substr(0, i).padStart(padLength + i - 1, " ") +
                        line.value.substr(j + 1);
                return;
            }
        }
    }
    function cleanMarkers(line) {
        let isBackArrowLine = false;
        for (let i = 0; i < line.value.length; i++) {
            let letter = line.value.charAt(i);
            switch (letter) {
                case "⚓":
                case "❌":
                case "✖":
                    let j = i + 1;
                    for (; j < line.value.length; j++) {
                        if (line.value.charAt(j) === " ") {
                            break;
                        }
                    }
                    line.value = line.value.substr(0, i) + line.value.substr(j + 1);
                    i = i - 1;
                    break;
                case "➕":
                case "➖":
                    line.value = line.value.substr(0, i) + line.value.substr(i + 1);
                    i = i - 1;
                    break;
                case "←":
                    line.value = line.value.substr(0, i) + line.value.substr(i + 1);
                    i = i - 1;
                    isBackArrowLine = true;
                    break;
                // case '⛓':
                //     line.value = line.value.substr(0, i) + (optionMargin === 'comfortable' ? '\n' : '') + line.value.substr(i + 1);
                //     i = i - 1;
                //     break;
                case "⧆":
                    line.value =
                        line.value.substr(0, i) + "" + line.value.substr(i + 1);
                    i = i - 1;
                    break;
                default:
                    break;
            }
        }
        if (isBackArrowLine)
            line.value = line.value.trim();
    }
    function makeSql() {
        let sql = "";
        lines.forEach((line, index) => {
            sql += line.value;
            if (index < lines.length - 1)
                sql += "\n";
        });
        return sql;
    }
}
exports.processData = processData;
